// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__e1gDi","unreadBadge":"styles_unreadBadge__L6sJb","modalContent":"styles_modalContent__3n_Ox","modal":"styles_modal__2VnNz"};